<script>
    import {extent} from "d3";
    import { beeSwarmData } from "../shared/stores.js";
    export let mainDrawColor;
    export let mainSpecialColor;
    // export let width;
    export let darkMode;
    export let innerWidth;
    // export let radius;
    // export let getRscale;
    export let rScale;
    // export let beeSwarmData;

    let width = 210
    let height=50
    let margin = ({ right: 20, left: 20, top:8})

    var range = (start, stop, step=1) => {
        const length = Math.ceil((stop - start) / step);
        return Array.from({length}, (_, i) => (i * step) + start);
    }

    function roundNearest5(num) {
        return Math.round(num / 5) * 5;
    }


    $: dataExtent = extent($beeSwarmData, d=>d.P15)
    $: step = dataExtent[1]/8

    // $: console.log(dataExtent)
    // $: console.log(dataExtent)
    // range(1, 6)

    let keepIndex = [0, 1, 4, 7]
    $: legendData = 
        range(dataExtent[0], dataExtent[1], step)
        .filter((d, i)=>keepIndex.includes(i))
        .map((d, i)=>{ return {
            P15:d,
            label:d<1000000?(String((d/1000).toFixed()))+"K":String((d/1000000).toFixed())+"M",
            // P15:d<1000000?(roundNearest5(d/100000)*100):roundNearest5(d/1000000)*1000000,
            // label:d<1000000?(String(roundNearest5(d/100000)*100))+"K":String(roundNearest5(d/1000000))+"M",
        }}
    )

    // $: console.log("leg data", legendData)
    // $: console.log("leg data", dataExtent)
    // $: console.log("leg data", rScale)

    // let legendData = [{P15:500000, label:"500K"},{P15:5000000, label:"5M"},{P15:10000000, label:"10M"},{P15:30000000, label:"30M"}]

    // $: rScale = getRscale(legendData, radius, innerWidth)

</script>

    <div class="legendContainer">
        <svg {width} {height} display=block margin=auto >
            <g transform={`translate(${width/2}, ${margin.top})`}>
                <text
                class="legendTicks"
                font-weight=700
                x={0}
                y={margin.top*0.8}
                text-anchor=middle
                fill={mainDrawColor}>
                    City population
                </text>
            </g>
            <g transform={`translate(${width/2-40},30)`}>
            <!-- <g transform={`translate(0,${margin.top})`}> -->
                {#if legendData!==null}
                    {#each legendData as data, i}
                        <circle
                        class="legendCircle"
                        cy={0}
                        cx={i*25}
                        r={rScale(data.P15)}
                        fill={darkMode===true?mainDrawColor:mainSpecialColor}
                        stroke={darkMode===true?mainDrawColor:mainSpecialColor}
                        stroke-width="0.7px"
                        fill-opacity={darkMode===true?1:0.2}
                        stroke-opacity=1
                        >
                        </circle>
                        <text
                        class="legendTicks"
                        fill={mainDrawColor}
                        y={15}
                        x={i*25}
                        text-anchor={"middle"}
                        >
                        {data.label}
                        </text>
                    {/each}
                {/if}
            </g>
        </svg>
    </div>

  <style>

    .legendTicks {
        /* font-family: 'Roboto', sans-serif; */
        /* font-family: 'DotGothic16', sans-serif; */
        /* font-size: 8px; */
        font-size: calc(8px + 0.15vw);
        /* font-weight: 400; */
        /* fill: black; */
		text-transform: uppercase;
    }

    .legendContainer {
    width:240px;
    /* height:100px; */
    margin:auto;
    }
  </style>